import nyatiServLogoSrc from '../../apps/nyati-serv/src/images/logo.png';
import dnsSolutionLogoSrc from '../../apps/dns-solution/src/images/logo.png';
import educoDistroLogoSrc from '../../apps/educo-distro/src/images/logo.png';
import cnlCafeLogoSrc from '../../apps/cnl-cafe/src/images/logo.png';
import dsTradingLogoSrc from '../../apps/ds-trading/src/images/logo.png';
import jemiellesLogoSrc from '../../apps/jemielles/src/images/logo.png';
import cheriLogoSrc from '../../apps/cheri/src/images/logo.png';
import vDistroLogoSrc from '../../apps/v-distro/src/images/logo.png';
import slarioLogoSrc from '../../apps/slario/src/images/logo.png';
import uniexpLogoSrc from '../../apps/uniexp/src/images/logo.png';
import tpkrutoyLogoSrc from '../../apps/tpkrutoy/src/images/logo.png';
import lottoreviewsiteLogoSrc from '../../apps/lottoreviewsite/src/images/logo.svg';
import onlineezsportsbettingLogoSrc from '../../apps/onlineezsportsbetting/src/images/logo.svg';
import luckynumbersforyouLogoSrc from '../../apps/luckynumbersforyou/src/images/logo.svg';
import luckylottopenLogoSrc from '../../apps/luckylottopen/src/images/logo.svg';
import winlottoproLogoSrc from '../../apps/winlottopro/src/images/logo.svg';
import fankyfactoryLogoSrc from '../../apps/fankyfactory/src/images/logo.svg';
import mElsLogoSrc from '../../apps/m-els/src/images/logo.svg';
import mmPawnLogoSrc from '../../apps/mmpawn/src/images/logo.png';
import europalaceLogoSrc from "../../apps/europalace/src/images/logo.png";
import zakapawnLogoSrc from "../../apps/zakapawn/src/images/logo.png";
import tpkLogoSrc from "../../apps/tpk/src/images/logo.png";
import virtuallearnersLogoSrc from "../../apps/virtuallearners/src/images/logo.png";
import bennemanTechLogoSrc from "../../apps/benneman-tech/src/images/logo.png";
import cVanZylLogoSrc from "../../apps/c-van-zyl/src/images/logo.png";
import comtechdistributorsLogoSrc from "../../apps/comtechdistributors/src/images/logo.png";
import infinityTechLogoSrc from "../../apps/infinity-tech/src/images/logo.png";
import linkieinternetcafeLogoSrc from "../../apps/linkieinternetcafe/src/images/logo.png";
import cherryOnlineLogoSrc from "../../apps/cherry-online/src/images/logo.png";
import mrBlackcardLogoSrc from "../../apps/mr-blackcard/src/images/logo.png";
import goMaujosEventsLogoSrc from "../../apps/go-maujos-events/src/images/logo.png";
import jeTechnologyLogoSrc from "../../apps/je-technology/src/images/logo.png";
import lnmbLogoSrc from "../../apps/lnmb/src/images/logo.png";
import africaRemoteSolutionsLogoSrc from "../../apps/africa-remote-solutions/src/images/logo.png";
import eclipseLoungeLogoSrc from "../../apps/eclipse-lounge/src/images/logo.png";

export const getLogoForCurrentSite = () => {
  if ( process.env.REACT_MERCHANT_NAME ) {
    switch (process.env.REACT_MERCHANT_NAME) {
      case 'dns-solution':
        return dnsSolutionLogoSrc;
      case 'nyati-serv':
        return nyatiServLogoSrc;
      case 'educo-distro':
        return educoDistroLogoSrc;
      case 'cnl-cafe':
        return cnlCafeLogoSrc;
      case 'ds-trading':
        return dsTradingLogoSrc;
      case 'jemielles':
        return jemiellesLogoSrc;
      case 'cheri':
        return cheriLogoSrc;
      case 'v-distro':
        return vDistroLogoSrc;
      case 'slario':
        return slarioLogoSrc;
      case 'uniexp':
        return uniexpLogoSrc;
      case 'tpkrutoy':
        return tpkrutoyLogoSrc;
      case 'lottoreviewsite':
        return lottoreviewsiteLogoSrc;
      case 'onlineezsportsbetting':
        return onlineezsportsbettingLogoSrc;
      case 'luckynumbersforyou':
        return luckynumbersforyouLogoSrc;
      case 'luckylottopen':
        return luckylottopenLogoSrc;
      case 'winlottopro':
        return winlottoproLogoSrc;
      case 'fankyfactory':
        return fankyfactoryLogoSrc;
      case 'm-els':
        return mElsLogoSrc;
      case 'mmpawn':
        return mmPawnLogoSrc;
      case 'europalace':
        return europalaceLogoSrc;
      case 'zakapawn':
        return zakapawnLogoSrc;
      case 'tpk':
        return tpkLogoSrc;
      case 'virtuallearners':
        return virtuallearnersLogoSrc;
      case 'benneman-tech':
        return bennemanTechLogoSrc;
      case 'c-van-zyl':
        return cVanZylLogoSrc;
      case 'comtechdistributors':
        return comtechdistributorsLogoSrc;
      case 'infinity-tech':
        return infinityTechLogoSrc;
      case 'linkieinternetcafe':
        return linkieinternetcafeLogoSrc;
      case 'cherry-online':
        return cherryOnlineLogoSrc;
      case 'mr-blackcard':
        return mrBlackcardLogoSrc;
      case 'go-maujos-events':
        return goMaujosEventsLogoSrc;
      case 'je-technology':
        return jeTechnologyLogoSrc;
      case 'lnmb':
        return lnmbLogoSrc;
      case 'africa-remote-solutions':
        return africaRemoteSolutionsLogoSrc;
      case 'eclipse-lounge':
        return eclipseLoungeLogoSrc;
      default:
        return null;
    }
  }
  return null;
};
